import React, { useEffect, useState } from "react";
import styled from "@emotion/styled";
const moment = require("moment");
import { showSuccessSnackbar, showErrorSnackbar } from "../../../redux/slices/snackbar";
import { useDispatch } from "react-redux";
import { useDialog } from "../../../contexts/DialogContext";
import SaveIcon from "@mui/icons-material/Save";
import useScheduleUser from "../../../hooks/useScheduleUser";

import {
  Grid,
  Divider as MuiDivider,
  Box,
  DialogActions,
  Button,
  CircularProgress,
  Typography as MuiTypography,
} from "@mui/material";
import { spacing } from "@mui/system";
import TextField from "@mui/material/TextField";
import { useForm, FormProvider } from "react-hook-form";
import useUser from "../../../hooks/useUser";
import useCafForm from "../../../hooks/useCafForm";

function ApproveOrReject(props) {
  const [action, setAction] = React.useState(null);
  const { refreshPage, selectedRows } = props;
  const { addScheduleUser } = useScheduleUser();

  const { approveCafForm, rejectCafForm, isApprove, isReject } = useCafForm();
  const dispatch = useDispatch();
  const { unSetDialog, openDialog } = useDialog();

  const methods = useForm();

  const {
    reset,
    handleSubmit,
    formState: { errors },
    control,
  } = methods;

  const onSubmit = async (data) => {
    try {
      if (selectedRows == 0) {
        return dispatch(showErrorSnackbar("Please select at least one CAF"));
      }
      try {
        if (action === "APPROVE") {
          await approveCafForm(selectedRows);
          dispatch(showSuccessSnackbar("CAF Approved Successfully!"));
        } else if (action === "REJECT") {
          await rejectCafForm(selectedRows);
          dispatch(showSuccessSnackbar("CAF Rejected Successfully!"));
        }
      } catch (err) {
        dispatch(showErrorSnackbar(err.message));
      }

      refreshPage();
      unSetDialog("approve_or_reject");
    } catch (err) {
      dispatch(showErrorSnackbar("Failed to Approve/Reject CAF"));
    }
  };

  return (
    <React.Fragment>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Grid container spacing={12} className="row" pt={8}>
            <Grid item md={6}>
              <i>Do you want to approve or reject selected CAFs?</i>
            </Grid>
          </Grid>
          <DialogActions>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              startIcon={<SaveIcon />}
              endIcon={isApprove ? <CircularProgress size={24} /> : null}
              disabled={isApprove}
              onClick={() => setAction("APPROVE")}
            >
              Approve
            </Button>

            <Button
              type="submit"
              variant="contained"
              color="error"
              startIcon={<SaveIcon />}
              endIcon={isReject ? <CircularProgress size={24} /> : null}
              disabled={isReject}
              onClick={() => setAction("REJECT")}
            >
              Reject
            </Button>
          </DialogActions>
        </form>
      </FormProvider>
    </React.Fragment>
  );
}

export default ApproveOrReject;
